// extracted by mini-css-extract-plugin
export default {"card":"_card_card__vZwGR","light":"_card_light__fKk5V","dark":"_card_dark__KV39k"};